import { render, staticRenderFns } from "./FastNavigationSidebar.vue?vue&type=template&id=53d1949f&scoped=true"
import script from "./FastNavigationSidebar.vue?vue&type=script&lang=ts"
export * from "./FastNavigationSidebar.vue?vue&type=script&lang=ts"
import style0 from "./FastNavigationSidebar.vue?vue&type=style&index=0&id=53d1949f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1949f",
  null
  
)

export default component.exports